import { useAui } from '@assistant-ui/react';
import { useEffect, useState } from 'react';

import { projectPromptParams } from '@playbooks/api';
import { Skeleton } from '@playbooks/molecules/skeletons';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

import { useStore } from 'contexts';
import { useAction, useInit } from 'hooks';
import { logger } from 'utils';

const AgentPrompts = ({ model, api, rootApi = '/project-prompts', onSelect = undefined }) => {
	const [prompts, setPrompts] = useState([]);
	const [params, setParams] = useState(projectPromptParams);
	const aui = useAui();
	const store = useStore();

	// Hooks
	useEffect(() => {
		if (model.id && api.type) fetchData();
	}, [model.id, api.type, params, rootApi]);

	// Hooks
	useEffect(() => {
		if (prompts.length) logger.log('prompts: ', { prompts });
	}, [prompts]);

	// Actions
	const [fetchData, loading] = useInit(async () => {
		const response = await store.query({
			url: rootApi,
			params: { ...params, ...api },
		});
		setPrompts(response.data);
	});

	const [fetchMore, moreTask] = useAction(async () => {
		const response = await store.query({
			url: rootApi,
			params: { ...params, ...api },
		});
		setPrompts(response.data);
	});

	const onPromptSelect = prompt => {
		if (onSelect) {
			onSelect(prompt);
			return;
		}

		aui.composer().setText(prompt);
	};

	// Render
	return (
		<div className='flex min-w-0 flex-1 items-center gap-2'>
			{loading || moreTask.running ? (
				<Skeleton layout='filter' />
			) : (
				<div className='custom-scrollbar flex min-w-0 flex-1 gap-2 overflow-x-auto'>
					{prompts.map((prompt: any) => (
						<Button
							variant='outline'
							key={prompt.id}
							size='sm'
							onClick={() => onPromptSelect(prompt.prompt)}
							className='flex-none bg-surface'>
							<Icon data-icon='inline-start' type='far' icon='sparkle' aria-hidden />
							{prompt.label}
							<Icon data-icon='inline-end' type='far' icon='arrow-up-right' aria-hidden />
						</Button>
					))}
				</div>
			)}
			<Button
				variant='outline'
				size='icon-sm'
				aria-label='refresh prompts'
				isLoading={moreTask.running}
				onClick={fetchMore}
				className='bg-surface'>
				<Icon data-icon='inline-start' type='far' icon='rotate' aria-hidden />
			</Button>
		</div>
	);
};

export { AgentPrompts };
